import React from 'react';
import { Star, RefreshCw } from 'lucide-react';
import GoogleReviewsBox from '../../GoogleReviewsBox';
import { Prospect } from './types';

interface GoogleMyBusinessCardProps {
  prospect: Prospect;
  onRefresh?: () => void;
}

const GoogleMyBusinessCard: React.FC<GoogleMyBusinessCardProps> = ({
  prospect,
  onRefresh
}) => {
  // Extraire le domaine du site URL
  const extractDomain = (url: string): string => {
    if (!url) return '';
    try {
      if (url.startsWith('http')) {
        const urlObj = new URL(url);
        return urlObj.hostname.replace(/^www\./, '');
      }
      return url.replace(/^(https?:\/\/)?(www\.)?/, '').split('/')[0].split('?')[0];
    } catch (error) {
      return url.replace(/^(https?:\/\/)?(www\.)?/, '').split('/')[0].split('?')[0];
    }
  };

  const getDomainFromProspect = (prospect: Prospect): string => {
    return prospect.site_url || prospect.metadata?.domain_emelia || '';
  };

  const handleRefresh = () => {
    if (onRefresh) {
      onRefresh();
    }
    // Forcer un rafraîchissement après un court délai
    setTimeout(() => window.location.reload(), 500);
  };

  return (
    <div className="space-y-3">
      {/* Header avec bouton de rafraîchissement */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="p-2 rounded-lg bg-yellow-50 text-yellow-700">
            <Star size={16} />
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-900">Avis Google Business</h4>
            <p className="text-xs text-gray-500">Réputation en ligne et avis clients</p>
          </div>
        </div>
        
        <button
          onClick={handleRefresh}
          className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          title="Actualiser les avis Google"
        >
          <RefreshCw size={16} />
        </button>
      </div>

      {/* Composant GoogleReviewsBox intégré */}
      <div className="min-h-[300px]">
        <GoogleReviewsBox 
          businessName={prospect.metadata?.company || prospect.nom || 'Entreprise'}
          location={prospect.metadata?.location}
          prospectId={prospect.id}
          domain={getDomainFromProspect(prospect)}
          className="h-full"
        />
      </div>

      {/* Informations supplémentaires */}
      <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded-md">
        <p>
          <strong>Entreprise :</strong> {prospect.metadata?.company || prospect.nom || 'Non renseignée'}
        </p>
        {prospect.metadata?.location && (
          <p>
            <strong>Localisation :</strong> {prospect.metadata.location}
          </p>
        )}
        <p>
          <strong>Domaine :</strong> {getDomainFromProspect(prospect) || 'Non renseigné'}
        </p>
      </div>
    </div>
  );
};

export default GoogleMyBusinessCard;
